
import { useState } from "react";
import ReportHeader from "./components/ReportHeader";
import ReportTable from "./components/ReportTable";
import Spinner from "../Spin/Spinner";
import { useSelector } from "react-redux";
import { getTransactionThroughOrderId } from "../../config/LiveApi";

function PayOutReport() {
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchType, setSearchType] = useState("");
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentItems, setCurrentItems] = useState(null);
  const [isSearching, setIsSearching] = useState(false);

  const token = useSelector((store) => store.userReducer.token);

  const hitFetchApi = async (searchType, searchText) => {
    if (!searchText?.trim()) return;
    setIsSearching(true);
    setIsLoading(true);
    try {
      const response = await getTransactionThroughOrderId(token, searchText);
      setTableData(response?.transactionDetail);
      setTotalPages(response?.meta?.pagination?.totalPages);
    } catch (error) {
      console.error("Error searching payout transaction:", error.message);
    }
    setIsLoading(false);
  };

  return (
    <div>
      <ReportHeader
        setSearchType={setSearchType}
        searchType={searchType}
        setSearchText={setSearchText}
        searchText={searchText}
        hitFetchApi={hitFetchApi}
        setParentStartDate={setStartDate}
        setParentEndDate={setEndDate}
      />

      <div>
        {isLoading ? (
          <Spinner />
        ) : (
          <ReportTable
            currentItems={currentItems || []}
            setCurrentItems={setCurrentItems}
            tableData={tableData || []}
            page={page}
            setPage={setPage}
            totalPages={totalPages}
            startDate={startDate}
            endDate={endDate}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            isSearching={isSearching}
          />
        )}
      </div>
    </div>
  );
}

export default PayOutReport;